import { render, staticRenderFns } from "./pot-1-terminal-modal.vue?vue&type=template&id=24e323f9"
import script from "./pot-1-terminal-modal.vue?vue&type=script&lang=js"
export * from "./pot-1-terminal-modal.vue?vue&type=script&lang=js"
import style0 from "./pot-1-terminal-modal.vue?vue&type=style&index=0&id=24e323f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./pot-1-terminal-modal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./pot-1-terminal-modal.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports